module.exports = __webpack_public_path__ + "img/08-approved.986fbf05.png";